export const en = {
  quietInHere: "It's quiet in here...",
  nothingHere: 'Nothing here?',
  hereYoullSee:
    'Here you will see new feedback from Clients and website visitors.',
  haventAlready: (manageProject: boolean) => [
    "If you haven't already, why not ",
    'invite a Client',
    ` or ${manageProject ? 'contact an administrator to ' : ''}enable `,
    'Public feedback',
    ' on your project.'
  ],
  feedbackYouLeave: (showOtherGuests: boolean) =>
    `Feedback you leave is sent here${
      showOtherGuests ? ', along with other client feedback' : ''
    }. Leave some feedback on the project, if you haven't already.`,
  managingFeedback: 'Managing your feedback efficiently',
  declutter: 'Declutter your Task Board with the Archive',
  archiveDescription:
    "When you archive your 'Done' tasks, they will be stored here. You can revisit archived tasks at any point, or even 'unarchive' them if you need to."
};

export type Translations = typeof en;
